
import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Question} from '@/lib/Question';

    @Component({})
    export default class DateQuestion extends Vue {
        @Prop() public question: Question;
        public day = 0;
        public month = 0;
        public year = 0;
        public yearPage = 1;
        public pickerDisplayed = 'none';


        public isDateFull(day, month, year){
            return day > 0 && year > 0 && month > 0;
        }

        public isCurrentDateFull(){
            return this.isDateFull(this.day, this.month, this.year);
        }

        public setDate(){
            this.question.currentResponse.value = this.day+'-'+this.month+'-'+this.year;
            this.question.validate();
            this.question.changedEvent.emit('changed');
        }

        public displayPicker(picker){
            this.pickerDisplayed = picker;
        }

        get years() {
            const size = 30;
            const current = new Date().getFullYear();
            const startYears = 1 + current - ((this.yearPage - 1) * size);
            return [...Array(size).keys()].map(i => i + startYears - size);
        }

        public isDateCorrect(day, month, year){
            if(this.isDateFull(day, month, year)){
                day = day < 10 ? '0'+day: day;
                month = month < 10 ? '0'+month: month;
                const date = new Date(`${year}-${month}-${day}`);
                return (Boolean(+date) && date.getDate() == day);
            }
            return false
        }

        public updateDay(day){
            if(false === this.isDateFull(day, this.month, this.year)){
                this.day = day;
                return;
            }
            if(this.isDateCorrect(day, this.month, this.year)){
                this.day = day;
                this.setDate();
            }
        }

        public updateMonth(month){
            if(false === this.isDateFull(this.day, month, this.year)){
                this.month = month;
                return;
            }
            if(this.isDateCorrect(this.day, month, this.year)){
                this.month = month;
                this.setDate();
            }
        }

        public updateYear(year){
            if(false === this.isDateFull(this.day, this.month, year)){
                this.year = year;
                return;
            }
            if( this.isDateCorrect(this.day, this.month, year)){
                this.year = year;
                this.setDate();
            }
        }

        public mounted(){
            if(this.question.currentResponse.value){
                const parts = this.question.currentResponse.value.split('-');
                if(parts.length < 3){
                    return;
                }
                const day = parseInt(parts[0]);
                const month = parseInt(parts[1]);
                const year = parseInt(parts[2]);
                if(this.isDateCorrect(day, month, year)){
                    this.day = day;
                    this.month = month;
                    this.year = year;
                }
            }
//            window.M.Datepicker.init(picker, {
//                format: 'dd-mm-yyyy',
//                onSelection(date) {
//                    question.currentResponse.value = moment(date).format('DD-MM-YYYY');
////                    this.close();
//                },
//                autoClose: true,
//                i18n: {
//                    cancel: 'Annuler',
//                    clear: 'Effacer',
//                    done: 'Ok',
//                    months: [
//                       'Janvier',
//                       'Fevrier',
//                       'Mars',
//                       'Avril',
//                       'Mai',
//                       'Juin',
//                       'Juillet',
//                       'Aout',
//                       'Septembre',
//                       'Octobre',
//                       'Novembre',
//                       'Decembre',
//                    ],
//                    monthsShort: [
//                        'Jan',
//                        'Fev',
//                        'Mar',
//                        'Avr',
//                        'Mai',
//                        'Juin',
//                        'Juil',
//                        'Aout',
//                        'Sep',
//                        'Oct',
//                        'Nov',
//                        ',Dec'
//                    ],
//                    weekdays: [
//                        'Dimanche',
//                        'Lundi',
//                        'Mardi',
//                        'Mercredi',
//                        'Jeudi',
//                        'Vendredi',
//                        'Samedi',
//                    ],
//                    weekdaysShort: [
//                        'Dimanche',
//                        'Lundi',
//                        'Mardi',
//                        'Mercredi',
//                        'Jeudi',
//                        'Vendredi',
//                        'Sam,edi'
//                    ],
//                    weekdaysAbbrev: [ 'D', 'L', 'M', 'M', 'J', 'V','S'],
//                    showMonthAfterYear: true,
//                    showClearBtn: true,
//                }
//            });
        }
        public beforeDestroy(){
//            const instance = window.M.Datepicker.getInstance(this.$refs['input-' + this.question.id]);
//            instance.destroy();
        }
    }
